import * as TYPES from "./type";

export const changeDeiveEdit = (payload: any) => ({
  type: TYPES.CHAGE_DEVICE_EDIT,
  payload,
});

export const changeDeviceDelete = (payload: any) => ({
  type: TYPES.CHANGE_DEVICE_DELETE,
  payload,
});
